import * as React from 'react';

import Playbook56 from './Playbook56';

export const playbook56 = () => <Playbook56 />;

export default {
    title: 'Illustration|Playbook56',
    component: Playbook56,
    parameters: {
        notes: "`import Playbook56 from 'box-ui-elements/es/illustration/Playbook56';`",
    },
};
